import { Button } from "primereact/button";

import type { BotaoIndicadoresProps } from "./types-botao-indicadores";
import styles from "./botao-indicadores.module.scss";

/** Botão que abre o modal de indicadores do Gantt: olho e "Indicadores", com borda, à direita da linha abaixo da legenda. */
export function BotaoIndicadoresView({ onClick, testId }: BotaoIndicadoresProps) {
  return (
    <div className={styles.linha}>
      <Button
        type="button"
        label="Indicadores"
        icon="pi pi-eye"
        severity="secondary"
        outlined
        aria-haspopup="dialog"
        onClick={onClick}
        data-testid={testId}
      />
    </div>
  );
}
